<script lang="ts">
    import inputfields from "./"

    let {
        ftpAssetsUrl,
        currentChoices = null,
        value = $bindable(),
        label,
        subFields,
        values = $bindable(),
        onInvalidConfig,
    }: FieldComponentProps = $props()
    if (!value) value = []
    values = values || null
</script>

<div class="object-array">
    {#if label}
        <label for="">{label}</label>
    {/if}
    {#each subFields || [] as field}
        {@const SvelteComponent =
            inputfields[(field.widget as keyof typeof inputfields) || (field.type as keyof typeof inputfields)] ||
            inputfields.default}

        <SvelteComponent
            {...field}
            {values}
            bind:value={value[field.name]}
            {currentChoices}
            {onInvalidConfig}
            {ftpAssetsUrl}
        />
    {/each}
</div>
